// extracted by mini-css-extract-plugin
module.exports = {"Text":"privacy_Text__IEi2L"};